<div class="card  mb-3">
  <div class="card-body">
    <div class=" mx-auto d-flex flex-column align-items-center">
      <h5 class="text-center" *ngIf="!isLoading">{{ "headers.routing.plan.normalized_workload" | translate }}</h5>
      <canvas baseChart [data]="barChartData" [options]="barChartOptions" [type]="barChartType"
        *ngIf="!isLoading"></canvas>
      <div class="spinner-border text-primary" role="status" *ngIf="isLoading">
      </div>
    </div>
  </div>
</div>
